import MGMComponent from 'components/marketingSite/memberGetMember/MGMComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type MemberGetMemberPageProps = WithBaseUrl;

const MemberGetMemberPage: React.FC<MemberGetMemberPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('member-get-member');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('member-get-member.page_title')}
        url={APP_URLS.memberGetMember}
        desc={t('member-get-member.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_member_get_member.png'
        )}`}
        indexable={true}
      />
      <MGMComponent />
    </>
  );
};

export default MemberGetMemberPage;

export const getStaticProps: GetStaticProps<MemberGetMemberPageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'member-get-member'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
